/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
const state = () => {
  const localStorageUser = JSON.parse(localStorage.getItem('user'));
  let finalState = {
    id: null,
    firstname: null,
    lastname: null,
    fullname: null,
    email: null,
    birth: null,
    gender: null,
    phone: null,
    loyaltyCode: null,
    goldCoins: null,
    referralCode: null,
  };

  if (localStorageUser) {
    finalState = {
      id: localStorageUser.id,
      firstname: localStorageUser.firstname,
      lastname: localStorageUser.lastname,
      fullname: localStorageUser.fullname,
      email: localStorageUser.email,
      birth: localStorageUser.birth ? new Date(localStorageUser.birth) : null,
      gender: localStorageUser.gender,
      phone: localStorageUser.phone,
      loyaltyCode: localStorageUser.loyaltyCode,
      goldCoins: localStorageUser.goldCoins,
      formattedGoldCoins: localStorageUser.formattedGoldCoins,
      referralCode: localStorageUser.referralCode,
    };
  }

  return {
    ...finalState,
  };
};

// getters
const getters = {
  loyaltyCode: state => state.loyaltyCode,
  birthYear: state => (state.birth ? state.birth.getFullYear() : null),
  birthMonth: state => (state.birth ? state.birth.getMonth() + 1 : null),
  birthDay: state => (state.birth ? state.birth.getDate() : null),
  hasProfileFilled: state => state.firstname &&
    state.lastname && state.birth && state.phone,
};

  // actions
const actions = {
  setUserFromLogin(
    { commit },
    // eslint-disable-next-line camelcase
    { id, firstname, lastname, email, birth, gender, phone, referral_code, loyalty_card, user_coin },
  ) {
    const birthDate = birth === null ? birth : new Date(birth);
    const user = {
      id,
      firstname,
      lastname,
      fullname: `${firstname} ${lastname}`,
      email,
      birth: birthDate,
      gender,
      phone,
      referralCode: referral_code,
      loyaltyCode: loyalty_card.code,
      goldCoins: user_coin.gold_coins,
      formattedGoldCoins: user_coin.formatted_gold_coins,
    };

    localStorage.setItem('user', JSON.stringify(user));

    commit('setUser', user);
  },
  setUserProfile(
    { commit, state },
    { firstname, lastname, birth, gender, phone },
  ) {
    const user = {
      ...state,
      firstname,
      lastname,
      fullname: `${firstname} ${lastname}`,
      phone,
      birth,
      gender,
    };
    localStorage.setItem('user', JSON.stringify(user));

    commit('setUser', user);
  },
  setUserCoins(
    { commit, state },
    // eslint-disable-next-line camelcase
    { gold_coins, formatted_gold_coins },
  ) {
    const updatedUser = {
      ...state,
      goldCoins: gold_coins,
      formattedGoldCoins: formatted_gold_coins,
    };

    localStorage.setItem('user', JSON.stringify(updatedUser));

    commit('setUser', updatedUser);
  },
  removeUser(
    { commit },
  ) {
    localStorage.removeItem('user');

    commit('removeUser');
  },
};

  // mutations
const mutations = {
  setUser(state,
    { id, lastname, fullname, email, birth, gender, referralCode, phone,
      loyaltyCode, goldCoins, formattedGoldCoins, firstname },
  ) {
    state.id = id;
    state.lastname = lastname;
    state.fullname = fullname;
    state.email = email;
    state.birth = birth;
    state.gender = gender;
    state.phone = phone;
    state.referralCode = referralCode;
    state.loyaltyCode = loyaltyCode;
    state.goldCoins = goldCoins;
    state.formattedGoldCoins = formattedGoldCoins;
    state.firstname = firstname;
  },
  removeUser(state) {
    state.id = null;
    state.lastname = null;
    state.fullname = null;
    state.email = null;
    state.birth = null;
    state.gender = null;
    state.phone = null;
    state.referralCode = null;
    state.loyaltyCode = null;
    state.goldCoins = null;
    state.formattedGoldCoins = null;
    state.firstname = null;
  },
  setUserReferralCode(state, referralCode = null) {
    state.referralCode = referralCode;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js